import React from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ApplicationUpdateApi>;
}

const GoZoneForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		register,
	} = form;

	return (
		<>
			<FormInput
				name="settings.code_validation"
				errors={errors}
				register={register}
				label={t("modules.app.field.code_validation.title")}
			/>
		</>
	);
};

export default GoZoneForm;
